// extracted by mini-css-extract-plugin
export default {"forbidden":"styles_forbidden__r3OzY"};